export const getMyEscapesActionQueryParams = (
  chatActionKey: App.ChatActions,
  itemId?: string,
  roomId?: string,
): Record<string, unknown> | undefined => {
  switch (chatActionKey) {
    case 'requestRefundAction':
      return { itemId, refundRequest: true }
    case 'requestDateChangeAction':
      return { itemId, requestDateChange: true }
    case 'shareBookingAction':
      return { shareBooking: true }
    case 'viewMapAction':
      return { viewMap: true }
    case 'specialRequestAction':
      return { itemId, specialRequest: true }
    case 'changeGuestNameAction':
      return roomId
        ? { itemId, roomId, changeGuestName: true }
        : { itemId, changeGuestName: true }
    default:
      return undefined
  }
}
